module.exports = __webpack_public_path__ + "img/8.png.f7eff00b.webp";